module.exports = __webpack_public_path__ + "static/media/work-from-home.06e06865.png";